export default "__VITE_ASSET__Bndkpz7$__"